import React, { useEffect, useRef, useState } from "react";

/** CountUp — smoothly animates from prev value to `value` over `duration` ms. */
export default function CountUp({ value, duration = 900, className = "" }) {
  const [display, setDisplay] = useState(value || 0);
  const prev = useRef(value || 0);
  const rafRef = useRef();

  useEffect(() => {
    const start = performance.now();
    const from = prev.current;
    const to = Number(value) || 0;
    if (from === to) { setDisplay(to); return; }
    const step = (t) => {
      const p = Math.min(1, (t - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3); // ease-out cubic
      setDisplay(Math.round(from + (to - from) * eased));
      if (p < 1) rafRef.current = requestAnimationFrame(step);
      else prev.current = to;
    };
    rafRef.current = requestAnimationFrame(step);
    return () => cancelAnimationFrame(rafRef.current);
  }, [value, duration]);

  return <span className={className}>{display.toLocaleString()}</span>;
}
